<template>
  <div>
    <HeroHome />

    <services />
    <aboutWeb />

    <!-- <cta :ctaText="$t('demodayPage.subtitle')" /> -->

    <benefits />
    <counterJSK />

    
    <featured />
 

    <footerJSK />
  </div>
</template>

<script>
import HeroHome from "./../components/HeroHome.vue";
import services from "./../components/services.vue";
import aboutWeb from "./../components/aboutWeb.vue";
import counterJSK from "./../components/counter.vue";
import benefits from "./../components/benefits.vue";
// import cta from "./../components/cta.vue";
import featured from "./../components/featured.vue";
import footerJSK from "./../components/footer.vue";




export default {
  name: "Home",
  components: {
    HeroHome,
    services,
    aboutWeb,
    counterJSK,
    // cta,
    benefits,
    featured,
    footerJSK
  },
  mounted () {
    window.scrollTo(0, 0)
  }
};
</script>


